"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinoffDepartment = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var Resources_1 = require("../../Resources");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var Units_1 = require("../../Units");
var SpinoffDepartment = (function (_super) {
    __extends(SpinoffDepartment, _super);
    function SpinoffDepartment() {
        return _super.call(this, {
            cost: 10,
            tags: [Tags_1.Tags.BUILDING],
            name: CardName_1.CardName.SPINOFF_DEPARTMENT,
            cardType: CardType_1.CardType.ACTIVE,
            productionBox: Units_1.Units.of({ megacredits: 2 }),
            metadata: {
                cardNumber: 'C41',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('WHEN PLAYING A CARD WITH A BASIC COST OF 20M€ OR MORE, draw a card.', function (eb) {
                        eb.megacredits(20).asterix().startEffect.cards(1);
                    }).br;
                    b.production(function (pb) { return pb.megacredits(2); });
                }),
                description: 'Increase your M€ production 2 steps.',
            },
        }) || this;
    }
    SpinoffDepartment.prototype.onCardPlayed = function (player, card) {
        if (card.cost >= 20) {
            player.drawCard();
        }
    };
    SpinoffDepartment.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        return undefined;
    };
    return SpinoffDepartment;
}(Card_1.Card));
exports.SpinoffDepartment = SpinoffDepartment;
//# sourceMappingURL=SpinoffDepartment.js.map